<template lang='pug'>
.page
  .list-group
    a.list-group-item.list-group-item-action.flex-column.align-items-start(href='#' v-for="call in calls.data" :key='call.id')
      .d-flex.w-100.justify-content-between
        h5.mb-1 {{ call.number | phoneNumber }}
        small
          span {{ call.calldate }}
          span(v-if='call.type!="outgoing"') <br>outbound
          span(v-if='call.type=="outgoing"') <br>inbound
          span(v-if='call.duration') <br>{{ call.duration }} sec
          span(v-else) <br>&nbsp;
      small
        span(@click='$emit("numSelected", call.number)') Call
</template>

<script >
  export default {
    // components: { Icon },
    data: function() {
      return {
        calls: {}
      }
    },
    props: {
      click2call: String,
    },
    methods: {
      updateList: function() {
        if ( this.click2call==='' ) {
          this.calls = {};
        } else {
          this.$http
            .get(global.apiurl + "/mobile-call-history&token=" + this.click2call)
            .then( response => {
              this.calls = response.body
          });
        }
      }
    },
    filters: {
        phoneNumber: function(value) {
          return value
                  .replace(/[^0-9]/g, '')
                  .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3')
                  .replace(/^(\d{1})(\d{3})(\d{3})(\d{4})$/, '$1 ($2) $3-$4');
        },
    },
    mounted() {
      // no need for set interval because it runs every time
      // its called under the router
      this.updateList();
      //setInterval(()=> { this.updateList(); }, 30000);
    },
    watch: {
      click2call() {
        this.updateList();
      }
    },
  }
</script>

<style scoped>
  .invisible {
    display: none !important;
  }
</style>
